import { useContext } from "react";
import { AuthContext } from "../services/context";
import { Outlet, Navigate } from "react-router-dom";

// This component is used to protect routes that are only accessible to
// sysAdmins. It checks the user's role and if it's not sysAdmin, it renders
// a NotFound component.
function SysAdminRoute() {
  const { user } = useContext(AuthContext);

  if (user?.role !== "sysAdmin") {
    return <Navigate to="/404" />;
  }

  return <Outlet />;
}

export default SysAdminRoute;
